import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react"
import { UseEquipoModeloTable } from "./UseEquipoModeloTable"
import themeBase from "../../../../utils/theme/themeBase"
import { useBoolean } from "@fluentui/react-hooks";
import { useState } from "react"
import { ITableModeloEquipoEdit } from "../../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo"
import { PanelEquipoModeloInsertar } from "./EquipoModeloInsertar/PanelEquipoModeloInsertar"
import { PanelEquipoModeloEliminar } from "./EquipoModeloEliminar/PanelEquipoModeloEliminar"
import { PanelEquipoModeloSync } from "./EquipoModeloSync/PanelEquipoModeloSync";
import IconHelper from "../../../../utils/helpers/iconHelper"
import { CabeceraTable } from "../../../../components/Table/CabeceraTable"
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent"

export const EquipoModeloTable = () => {

  const {items, loading, pagination, handleResetUpdate, onChangeTake, _onkeyUpSearchTable, onChangeSearch} = UseEquipoModeloTable()
  const [isOpenEquipo, { setTrue: openPanelEquipo, setFalse: closePanelEquipo }] = useBoolean(false);
  const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
  const [isOpenSYNC, { setTrue: openPanelSYNC, setFalse: closePanelSYNC }] = useBoolean(false);

  const [item, setItem] = useState<ITableModeloEquipoEdit>({
    equipo: "",
    codigo: "",
    tipoEquipoId: "",
    equipoModeloId: ""
  })

  const buttonLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD_TABLE,
      text: "Nuevo",
      onClick: openPanelEquipo,
    },
    {
      ...IconHelper.ICON_RELOAD2,
      text: "Sincronizar",
      onClick: openPanelSYNC,
    },
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: handleResetUpdate,
    }
  ];

  function renderOpciones(item: ITableModeloEquipoEdit) {
    return (
      <>
        <TooltipHost content={"Quitar"}>
          <Icon
            iconName="Delete"
            className={themeBase.classNamesIcon.iconFont}
            style={{ cursor: "pointer", color: "#0078d3" }}
            onClick={() => {
              setItem(item)
              openPanelEliminar()
            }}
          />
        </TooltipHost>
      </>
    );
  }

  const _columns = [
    {
      key: "modelo",
      name: "Modelo",
      fieldName: "equipo",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "tipoEquipo",
      name: "TipoEquipo",
      fieldName: "tipoEquipo",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "fechaModificacion",
      name: "Fecha Modificación",
      fieldName: "fechaModificacion",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 100,
      maxWidth: 300,
      onRender: (item: ITableModeloEquipoEdit) => renderOpciones(item)
    }
  ]

  return (
    <>
      <CabeceraTable
        Titulo={"Modelo de Equipos"}
        SubTitulo={"Gestión de Modelo de Equipos"}
        placeholder="Buscar por Modelo del Equipo"
        componentRef={onChangeSearch}
        onKeyUp={_onkeyUpSearchTable}
      />

      <TableBaseComponent
        leftBar={buttonLeft}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
      />

      <PanelEquipoModeloInsertar
        isOpen={isOpenEquipo}
        onDismiss={closePanelEquipo}
        reload={handleResetUpdate}
      />

      <PanelEquipoModeloEliminar
        item={item}
        isOpen={isOpenEliminar}
        onDismiss={closePanelEliminar}
        reload={handleResetUpdate}
      />

      <PanelEquipoModeloSync
        isOpen={isOpenSYNC}
        onDismiss={closePanelSYNC}
        reload={handleResetUpdate}
      />
    </>
  )
}